import { ProductListDTO } from '../product/product-list.dto';
import { PricelistListDTO } from '../pricelist/pricelist-list.dto';
import { TeamAccessDTO } from '../team/team-access.dto';

export class PricelistItemDTO extends TeamAccessDTO {

    id: string;
    
    price: number;

    product: ProductListDTO;

    pricelist: PricelistListDTO;

}
